import styled from 'styled-components'

type LabelProps = {
	type: 'title' | 'paragraph'
	margin?: number
}

type ButtonProps = {
	label?: boolean
}

export const Container = styled.div`
	display: block;
	position: fixed;
	z-index: 1;
	padding-top: 50%;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	overflow: auto;
	background-color: rgb(0, 0, 0);
	background-color: rgba(0, 0, 0, 0.4);
`

export const Content = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	align-items: center;
	text-align: center;
	margin: auto;
	width: 325px;
	height: 340px;
	background: #ffffff;
	border-radius: 10px;

	a {
		text-decoration: underline;
		color: #64778f;
		font-weight: 500;
	}
`

export const ImgContainer = styled.div`
	display: flex;
	align-items: center;
	text-align: center;
	place-content: center;
	height: 50px;
	margin-top: 10px;
`

export const Label = styled.p<LabelProps>`
	font-family: 'Montserrat', Arial, sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: ${({ type }) => (type === 'title' ? '18px' : '16px')};
	line-height: ${({ type }) => (type === 'title' ? '28px' : '24px')};
	display: flex;
	align-items: center;
	text-align: center;
	place-content: center;
	color: #64778f;
	margin: ${({ margin }) => `0 ${margin}px`};
`

export const Button = styled.button<ButtonProps>`
	height: 40px;
	background: ${({ label }) => (label ? 'transparent' : '#5082c2')};
	width: 100%;
	border: none;
	color: ${({ label }) => (label ? '#5082c2' : '#fff')};
	font-family: 'Montserrat', Arial, sans-serif;
	font-weight: 500;
	font-size: 16px;
	border-radius: 4px;
	padding: 0 6px;
`

export const ActionButtons = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-gap: 10px;
	padding: 0 10px;
`
